/**
 * Comparaison stricte : la version côté serveur peut être plus ancienne que le bundle
 * (rollback, base pas à jour), et une valeur non numérique ne doit rien déclencher.
 *
 * @param {string} candidate
 * @param {string} current
 * @return {boolean}
 */
export default function isNewerVersion(candidate, current) {
    if (!candidate || !current) return false;

    const toParts = (version) => String(version).split('.').map(Number);
    const candidateParts = toParts(candidate);
    const currentParts = toParts(current);

    if ([...candidateParts, ...currentParts].some(Number.isNaN)) return false;

    for (let index = 0; index < Math.max(candidateParts.length, currentParts.length); index++) {
        const candidatePart = candidateParts[index] ?? 0;
        const currentPart = currentParts[index] ?? 0;

        if (candidatePart !== currentPart) return candidatePart > currentPart;
    }

    return false;
}
